enum FieldDataType {
  STRING = 'DATA_TYPE_STRING',
  INT = 'DATA_TYPE_INT',
  FLOAT = 'DATA_TYPE_FLOAT',
}

export default FieldDataType;
